import store from 'store';
import _ from 'underscore';
import { actionSetActionForm } from 'redux/actions/FormAction';
import { t } from '@lingui/core/macro';

function makeLineBreak({ isBody = false }) {
    const className = isBody ? 'form-body-break invisible-break' : undefined;
    return {
        type: 'fieldset',
        name: 'Break Line',
        grids: [
            {
                type: 'grid',
                fields: [
                    {
                        type: 'breakline',
                        id: generateId('field_rn1519982341530'),
                        className,
                    },
                ],
            },
        ],
        id: generateId('fieldset_breakline'),
    };
}

function generateId({ fieldName = 'field' }) {
    // Generate a unique ID for the field
    // This is to prevent the existing builder to overwrite the value by retrieving
    // the same field name from the store, in short force to use the new value associated
    return String(fieldName) + '_' + Math.random().toString(8);
}

function formatDisplay(display) {
    if (display == null) return 'N/A';

    if (typeof display === 'string') {
        display = display.trim() || 'N/A';
        return display.replace(/_/g, ' ').toUpperCase();
    }

    return display;
}

function populateRiskCheckReports({ applicationId, riskCheckReports = [] }) {
    const body = [];
    Object.entries(riskCheckReports).forEach(([key, value]) => {
        // if it is a list of results for a category, add a header
        // then add subheaders for each result
        if (Array.isArray(value.subdisplay) && value.subdisplay.length > 0) {
            body.push({
                type: 'fieldset',
                name: 'Risk Check Reports/Results',
                grids: [
                    {
                        type: 'grid',
                        fields: [
                            {
                                type: 'label',
                                title: formatDisplay(key),
                                id: generateId(applicationId),
                                bold: true,
                            },
                        ],
                    },
                ],
            });

            const len = value.subdisplay.length;
            for (let i = 0; i < len; i++) {
                body.push({
                    type: 'fieldset',
                    name: 'Risk Check Reports/Results',
                    grids: [
                        {
                            type: 'grid',
                            fields: [
                                {
                                    type: 'label',
                                    title: ' - ' + formatDisplay(value?.subdisplay[i] ?? ''),
                                    id: generateId(applicationId),
                                    bold: true,
                                },
                            ],
                        },
                        {
                            type: 'grid',
                            fields: [
                                {
                                    type: 'text',
                                    value: formatDisplay(value?.decision[i] ?? ''),
                                    id: generateId(value.decision_id),
                                },
                            ],
                            isEditable: false,
                        },
                        {
                            type: 'grid',
                            fields: [
                                {
                                    id: generateId(value.file_id),
                                    type: 'upload',
                                    value: value?.files[i] ?? [],
                                    hideUploadButton: true,
                                },
                            ],
                            isEditable: false,
                        },
                    ],
                    id: generateId('fieldset_risk_reports'),
                });
            }

            body.push(makeLineBreak({ isBody: true }));
            return;
        }

        body.push({
            type: 'fieldset',
            name: 'Risk Check Reports/Results',
            grids: [
                {
                    type: 'grid',
                    fields: [
                        {
                            type: 'label',
                            title: formatDisplay(key),
                            id: generateId(applicationId),
                            bold: true,
                        },
                    ],
                },
                {
                    type: 'grid',
                    fields: [
                        {
                            type: 'text',
                            value: formatDisplay(value.decision),
                            id: generateId(value.decision_id),
                        },
                    ],
                    isEditable: false,
                },
                {
                    type: 'grid',
                    fields: [
                        {
                            id: generateId(value.file_id),
                            type: 'upload',
                            hideUploadButton: true,
                            value: value.files,
                        },
                    ],
                    isEditable: false,
                },
            ],
            id: generateId('fieldset_risk_reports'),
        });
        body.push(makeLineBreak({ isBody: true }));
    });

    return body;
}

function createViewRiskForm({ applicationId, formStatus, riskCheckReports = [] }) {
    const body = populateRiskCheckReports({
        applicationId,
        riskCheckReports,
    });

    const header = [
        {
            type: 'fieldset',
            grids: [
                {
                    type: 'grid',
                    fields: [
                        {
                            type: 'label',
                            name: 'Application ID [Label]',
                            title: `Application: ${applicationId}`,
                            id: generateId(applicationId),
                            bold: true,
                        },
                    ],
                },
                {
                    type: 'grid',
                    className: 'decline-form-status',
                    fields: [
                        {
                            type: 'label',
                            name: 'Status [Label]',
                            title: t({
                                message: `Status: ${formStatus}`,
                                context: 'FormStatus',
                            }),
                            id: generateId(formStatus),
                        },
                    ],
                },
            ],
        },
        makeLineBreak({ isBody: false }),
    ];

    const fieldsets = [...header, ...body];

    const form = {
        views: [
            {
                type: 'view',
                sections: [
                    {
                        type: 'section',
                        title: 'Section View Risk',
                        name: 'View Risk Section',
                        fieldsets: fieldsets,
                    },
                ],
            },
        ],
    };

    const buttons = [
        {
            title: 'Close',
            name: 'close',
            buttonType: 'secondary',
            onClick: () => {
                store.dispatch(actionSetActionForm({}));
            },
        },
    ];
    return { form, buttons };
}

export default createViewRiskForm;
